// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__AddItemButton from "../../../components/atoms/AddItemButton.js";
import * as Buhta_cabinet__Api from "../../../core/Api.js";
import * as Buhta_cabinet__Crm from "../../../models/Crm.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__Dropdown from "../../../components/html/Dropdown.js";
import * as Buhta_cabinet__HelpChatLayout from "./HelpChatLayout.js";
import * as Buhta_cabinet__Input from "../../../components/html/Input.js";
import * as Buhta_cabinet__ListWithPreview from "../../../components/molecules/ListWithPreview.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__Panel from "../../../components/html/Panel.js";
import * as Buhta_cabinet__Request from "../../../core/Request.js";
import * as Buhta_cabinet__Route from "../../../Route.js";
import * as Buhta_cabinet__Select from "../../../components/html/Select.js";
import * as Buhta_components__LoadingDiv from "../../../../../../packages/components/src/atoms/LoadingDiv.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../../packages/util/lib/DateTime.js";
import * as Stdlib from "melange/stdlib.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import ArchiveSvg from "static/icons/archive.svg";
import CloseCircleSvg from "static/icons/close-circle.svg";
import SelectArrowsSvg from "static/icons/select-arrows.svg";

function make(colorOpt) {
  const color = colorOpt !== undefined ? colorOpt : "text-success";
  return function (text) {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                      className: "text-white",
                      children: text
                    }),
                className: Cn.fromList({
                      hd: "px-2 py-0.5 bordered-20px",
                      tl: {
                        hd: color,
                        tl: /* [] */0
                      }
                    })
              });
  };
}

function HelpCenter$BgColoredText(Props) {
  return make(Props.color)(Props.text);
}

const BgColoredText = {
  make: HelpCenter$BgColoredText
};

const _map = {"unread":"unread","default":"default","archived":"archived"};

function kindToJs(param) {
  return param;
}

function kindFromJs(param) {
  return _map[param];
}

function container(kind, active) {
  const activeBg = Caml_obj.caml_equal(kind, "unread") ? "bg-unread" : (
      active ? "bg-gray-light" : "bg-white"
    );
  return "px-6 py-4 cursor-pointer hover:bg-gray-light grow-0 shrink-0 " + activeBg;
}

const cardHeader = "flex items-center justify-between";

const cardText = "overflow-hidden";

const Styles = {
  container: container,
  cardHeader: cardHeader,
  cardText: cardText
};

function make$1(ticket) {
  return function (currentTicketId) {
    return function (onClick) {
      return function (unreadMessagesOpt) {
        const unreadMessages = unreadMessagesOpt !== undefined ? unreadMessagesOpt : 0;
        const id = ticket.id;
        const match = ticket.status;
        let kind;
        switch (match) {
          case "closed" :
              kind = "archived";
              break;
          case "commented" :
          case "opened" :
              kind = "unread";
              break;
          default:
            kind = "default";
        }
        const textColorStr = kind === "archived" ? "text-gray-medium" : "text-black";
        return JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              Caml_obj.caml_equal(kind, "archived") ? JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(ArchiveSvg, {}),
                                      className: "mr-2"
                                    }) : null,
                              JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                                    nowrap: true,
                                    className: Cn.fromList({
                                          hd: "mr-1",
                                          tl: {
                                            hd: textColorStr,
                                            tl: /* [] */0
                                          }
                                        }),
                                    children: ticket.org.name
                                  }),
                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                    nowrap: true,
                                    className: "ml-auto text-default-gray",
                                    children: DateTime.toLocalFormat(ticket.updated_at)
                                  })
                            ],
                            className: cardHeader
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                    className: Cn.fromList({
                                          hd: cardText,
                                          tl: {
                                            hd: textColorStr,
                                            tl: /* [] */0
                                          }
                                        }),
                                    children: ticket.answered.display_name + (" " + ticket.preview)
                                  }),
                              kind === "archived" ? null : (
                                  kind === "default" ? (
                                      unreadMessages === 0 ? null : JsxRuntime.jsx(HelpCenter$BgColoredText, {
                                              color: "text-secondary",
                                              text: String(unreadMessages)
                                            })
                                    ) : JsxRuntime.jsx(HelpCenter$BgColoredText, {
                                          text: "Новый"
                                        })
                                )
                            ],
                            className: "flex items-center justify-between mt-1"
                          })
                    ],
                    className: Cn.fromList({
                          hd: container(kind, Belt__Belt_Option.mapWithDefault(currentTicketId, false, (function (ticketId) {
                                      return ticketId === id;
                                    }))),
                          tl: {
                            hd: "basis-24",
                            tl: /* [] */0
                          }
                        }),
                    onClick: (function (param) {
                        Curry._1(onClick, id);
                      })
                  });
      };
    };
  };
}

function HelpCenter$TicketCard(Props) {
  return Curry._2(make$1(Props.ticket)(Props.currentTicketId), Props.onClick, Props.unreadMessages);
}

const TicketCard = {
  kindToJs: kindToJs,
  kindFromJs: kindFromJs,
  Styles: Styles,
  make: HelpCenter$TicketCard
};

const container$1 = "p-4 pt-3 w-64";

const filter_row = "flex items-center";

const Styles$1 = {
  container: container$1,
  filter_row: filter_row
};

function make$2(status) {
  return function (setStatus) {
    return function (param) {
      return function (setOrgParam) {
        const match = React.useState(function () {
              return false;
            });
        const setIsDropdownShown = match[1];
        const match$1 = React.useState(function () {
              
            });
        const setOrg = match$1[1];
        const org = match$1[0];
        const setOrg$1 = function (option) {
          Curry._1(setOrgParam, Belt__Belt_Option.map(option, (function (option) {
                      return String(option.value);
                    })));
          Curry._1(setOrg, (function (param) {
                  return option;
                }));
          Curry._1(setIsDropdownShown, (function (param) {
                  return false;
                }));
        };
        const activator = function (param) {
          return JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              children: "Фильтр"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(SelectArrowsSvg, {})
                            })
                      ],
                      className: "flex items-center"
                    });
        };
        const options = {
          hd: {
            value: "all",
            text: "Все запросы"
          },
          tl: {
            hd: {
              value: "opened",
              text: "Все новые запросы"
            },
            tl: {
              hd: {
                value: "closed",
                text: "Все закрытые запросы"
              },
              tl: /* [] */0
            }
          }
        };
        const arg = Buhta_cabinet__Crm.Org.grid;
        const arg$1 = Curry._2(Buhta_cabinet__Api.Endpoints.Crm.orgs, undefined, undefined);
        return JsxRuntime.jsx(Buhta_cabinet__Dropdown.Custom.make, {
                    align: "BottomCenter",
                    activator: activator,
                    background: "bg-asphalt-dark",
                    isDropdownShown: match[0],
                    setIsDropdownShown: setIsDropdownShown,
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(Buhta_components__Text.H6.make, {
                                  className: "text-default-gray",
                                  children: "Фильтр"
                                }),
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(Buhta_cabinet__Select.make, {
                                          options: options,
                                          label: "Статус",
                                          selectedOption: Buhta_cabinet__Select.findSomeInList(options, status),
                                          onChange: (function (option) {
                                              Curry._1(setIsDropdownShown, (function (param) {
                                                      return false;
                                                    }));
                                              Curry._1(setStatus, Belt__Belt_Option.map(option, (function (option) {
                                                          return option.value;
                                                        })));
                                            }),
                                          whiteMode: false,
                                          labelFloating: false
                                        }),
                                    Belt__Belt_Option.isSome(status) ? JsxRuntime.jsx("button", {
                                            children: JsxRuntime.jsx(CloseCircleSvg, {}),
                                            onClick: (function (param) {
                                                Curry._1(setIsDropdownShown, (function (param) {
                                                        return false;
                                                      }));
                                                Curry._1(setStatus, undefined);
                                              })
                                          }) : null
                                  ],
                                  className: filter_row
                                }),
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(Buhta_cabinet__Select.Searchable.make, {
                                          label: "Предприятие",
                                          useFetch: (function (param) {
                                              const func = function (param$1, param$2, param$3) {
                                                return Buhta_cabinet__Request.useGrid(param, arg$1, param$1, param$2, param$3);
                                              };
                                              return function (param) {
                                                return Curry._2(func, param, arg);
                                              };
                                            }),
                                          mapper: (function (item) {
                                              return {
                                                      value: item.id,
                                                      text: item.name
                                                    };
                                            }),
                                          selectedOption: org,
                                          onChange: setOrg$1,
                                          whiteMode: false,
                                          labelFloating: false
                                        }),
                                    Belt__Belt_Option.isSome(org) ? JsxRuntime.jsx("button", {
                                            children: JsxRuntime.jsx(CloseCircleSvg, {}),
                                            onClick: (function (param) {
                                                setOrg$1(undefined);
                                              })
                                          }) : null
                                  ],
                                  className: filter_row
                                })
                          ],
                          className: container$1
                        })
                  });
      };
    };
  };
}

function HelpCenter$Filter(Props) {
  return Curry._2(make$2(Props.status)(Props.setStatus), Props.org, Props.setOrg);
}

const Filter = {
  Styles: Styles$1,
  make: HelpCenter$Filter
};

function HelpCenter(Props) {
  const match = React.useState(function () {
        return "";
      });
  const setSearchText = match[1];
  const url = Buhta_cabinet__Route.useUrl(undefined);
  const match$1 = Buhta_cabinet__Route.useParamValue(url, "status");
  const status = match$1[0];
  const match$2 = Buhta_cabinet__Route.useParamValue(url, "org");
  const org = match$2[0];
  const match$3 = Buhta_cabinet__Request.useFilters2([
        "status",
        status
      ], [
        "org",
        org
      ]);
  const filters = match$3[0];
  const match$4 = React.useState(function () {
        return {
                filter: filters,
                params: undefined
              };
      });
  const setParams = match$4[1];
  const params = match$4[0];
  const handleSearch = function (value) {
    Curry._1(setSearchText, (function (param) {
            return value;
          }));
    Curry._1(setParams, (function (param) {
            return {
                    filter: Stdlib.$at(filters, {
                          hd: [
                            "query",
                            value
                          ],
                          tl: /* [] */0
                        }),
                    params: params.params
                  };
          }));
  };
  const urlApi = Curry._2(Buhta_cabinet__Api.Endpoints.Crm.tickets, undefined, undefined);
  const match$5 = Buhta_cabinet__Request.useGrid(undefined, urlApi, params, Buhta_cabinet__Crm.Ticket.grid, undefined);
  const grid = match$5[0];
  const match$6 = React.useState(function () {
        
      });
  const setCurrentChatId = match$6[1];
  const currentChatId = match$6[0];
  const header = JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
        title: "Помощь"
      });
  return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
              header: header,
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(Buhta_cabinet__Panel.make, {
                            title: "",
                            leftActions: {
                              hd: JsxRuntime.jsx(Buhta_cabinet__Input.make, {
                                    value: match[0],
                                    placeholder: "Поиск...",
                                    type_: "text",
                                    onChange: handleSearch
                                  }),
                              tl: /* [] */0
                            },
                            rightActions: {
                              hd: JsxRuntime.jsx(HelpCenter$Filter, {
                                    status: status,
                                    setStatus: match$1[1],
                                    org: org,
                                    setOrg: match$2[1]
                                  }),
                              tl: {
                                hd: JsxRuntime.jsx(Buhta_cabinet__AddItemButton.make, {
                                      onClick: (function (param) {
                                          Buhta_cabinet__Route.navigateTo({
                                                TAG: /* Admin */7,
                                                _0: {
                                                  TAG: /* Help */3,
                                                  _0: /* Tickets */{
                                                    _0: /* Create */1
                                                  }
                                                }
                                              });
                                        }),
                                      children: "Тикет"
                                    }),
                                tl: /* [] */0
                              }
                            },
                            className: "border-r border-solid border-gray-main",
                            children: typeof grid === "string" ? JsxRuntime.jsx(Buhta_components__LoadingDiv.make, {}) : (
                                grid.NAME === "Data" ? Belt__Belt_List.toArray(Belt__Belt_List.map(grid.VAL.data, (function (ticket) {
                                              const Key = String(ticket.id);
                                              return JsxRuntime.jsx(HelpCenter$TicketCard, {
                                                          ticket: ticket,
                                                          currentTicketId: currentChatId,
                                                          onClick: (function (id) {
                                                              Curry._1(setCurrentChatId, (function (param) {
                                                                      return id;
                                                                    }));
                                                            })
                                                        }, Key);
                                            }))) : JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                        children: "Error"
                                      })
                              )
                          }),
                      currentChatId !== undefined ? JsxRuntime.jsx(Buhta_cabinet__HelpChatLayout.make, {
                              id: currentChatId,
                              onClose: (function (param) {
                                  Curry._1(setCurrentChatId, (function (param) {
                                          
                                        }));
                                })
                            }) : JsxRuntime.jsx(Buhta_cabinet__ListWithPreview.Placeholder.make, {
                              children: JsxRuntime.jsx(Buhta_components__Text.H3.make, {
                                    className: "",
                                    children: "Выберите чат"
                                  })
                            })
                    ],
                    className: "grid h-full grid-cols-[minmax(0,3fr)_minmax(0,9fr)]"
                  })
            });
}

const make$3 = HelpCenter;

export {
  BgColoredText ,
  TicketCard ,
  Filter ,
  make$3 as make,
}
/* Buhta_cabinet__AddItemButton Not a pure module */
